import Chaplin from 'chaplin';

const Menu = Chaplin.Model.extend({
  path: function () {
    return this.get('key');
  },
});

export default Menu;
